import { render, staticRenderFns } from "./PDFVentas.vue?vue&type=template&id=3950f9dc&"
import script from "./PDFVentas.vue?vue&type=script&lang=js&"
export * from "./PDFVentas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports